var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { queueSafetyChangeForDeviation, recordDeviationSafety, setPageSafety, } from './actions';
import { reduxKey } from './constants';
var handler = handleActions((_a = {},
    _a[setPageSafety.toString()] = function (state, action) { return (__assign(__assign({}, state), { currentSafety: action.payload.safety })); },
    _a[recordDeviationSafety.toString()] = function (state, action) {
        var _a;
        return (__assign(__assign({}, state), { deviationSafety: __assign(__assign({}, state.deviationSafety), (_a = {}, _a[action.payload.deviationId] = action.payload.safety, _a)) }));
    },
    _a[queueSafetyChangeForDeviation.toString()] = function (state, action) { return (__assign(__assign({}, state), { queuedDeviationId: action.payload.deviationId })); },
    _a), { currentSafety: 'unlikely', deviationSafety: {} });
var reducers = (_b = {},
    _b[reduxKey] = handler,
    _b);
export default reducers;
//# sourceMappingURL=reducer.js.map